import { getSelectedTableView, getListViewState, MailRowDataPropertyGetter, } from "owa-mail-list-store";
import type { ActionSource } from "owa-analytics-types";
import type { ClientItemId } from "owa-client-ids";
import { lazyPrintConversation, lazyPrintItem } from "owa-mail-message-actions";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import { resetFocus } from "owa-mail-focus-manager";
import getExpandedItemId from "../utils/getExpandedItemId";
import { getActiveContentTab, TabType } from "owa-tab-store";
import { isReadingPaneStackedView } from "owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils";

export default async function onPrint(actionSource: ActionSource, targetWindow?: Window): Promise<void> {
    const printStartTime = Date.now();
    let itemId: ClientItemId | undefined;
    let printAction: typeof lazyPrintItem | typeof lazyPrintConversation = lazyPrintItem;
    // If there is an active secondary tab, print from there
    const activeTab = getActiveContentTab();
    if (activeTab && activeTab.type === TabType.SecondaryReadingPane) {
        const secondaryReadingPaneTabData = activeTab.data;
        const itemOrConversationId = secondaryReadingPaneTabData.id;
        switch (secondaryReadingPaneTabData.listViewType) {
            case 0:
                itemId = itemOrConversationId;
                if (isReadingPaneStackedView(undefined /*listViewType*/)) {
                    printAction = lazyPrintConversation;
                }
                break;
            case 1:
                itemId = itemOrConversationId;
                break;
        }
    }
    else {
        const tableView = getSelectedTableView();
        
        const nodeIds = getListViewState().expandedConversationViewState.selectedNodeIds;
        if (nodeIds.length === 1) {
            itemId = getExpandedItemId(tableView, nodeIds);
        }
        else {
            const rowKeys = [...tableView.selectedRowKeys.keys()];
            const selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKeys[0], tableView);
            switch (tableView.tableQuery.listViewType) {
                case 0:
                    itemId = selectedRowId;
                    printAction = lazyPrintConversation;
                    break;
                
                case 1:
                    itemId = selectedRowId;
                    break;
            }
        }
    }
    
    // Capture the print target before resetting focus, then finish the reset before opening a dialog.
    await resetFocus("printCommand");
    if (itemId) {
        printAction.importAndExecute(itemId, actionSource, targetWindow, printStartTime);
    }
}
